// const URL = 'https://mjsremz2g4.execute-api.us-west-2.amazonaws.com/prod/';

// export const END_POINT = `${URL}`;
export const END_POINT = `http://44.231.119.63:8080/`;
// export const END_POINT = `http://localhost:8080/`;